import styled from 'styled-components';
import { H1, SectionParent } from '../../StyledComponents';

import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';

const BenefitsTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  color: #725cbd;
`;

const BenefitsDescription = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #54586b;
`;
const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-image: linear-gradient(to bottom, #fafbfe 0%, #fafbfe 99%);
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  z-index: 2;
  position: relative;
  padding-top: 5rem !important;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #1b2341;

  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    color: #1b2341;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  max-width: 64rem;
  margin: auto;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #54586b;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
    margin-right: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const CareerPageValuesSection = styled.div`
  display: grid;
  margin-top: 5rem;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 5rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-gap: 3rem 0rem;
  }
`;
const ValueItem = styled.div`
  grid-column: span 1;
  @media (max-width: 768px) {
    grid-column: span 3;
  }
`;
const ValueImg = styled(GatsbyImage)`
  height: 180px;
  width: 100%;
  margin-bottom: 1rem;
  img {
    object-fit: contain !important;
  }
`;

export default () => (
  <StaticQuery
    query={graphql`
      query {
        ownership: file(relativePath: { eq: "v2/png/careers/ownership.png" }) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        honesty: file(relativePath: { eq: "v2/png/careers/honesty@3x.png" }) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
        batmanjoker: file(
          relativePath: { eq: "v2/png/careers/batman-joker@3x.png" }
        ) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        raisethebar: file(
          relativePath: { eq: "v2/png/careers/raise-the-bar@3x.png" }
        ) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        diversity: file(
          relativePath: { eq: "v2/png/careers/diversity@3x.png" }
        ) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        people: file(relativePath: { eq: "v2/png/careers/people@3x.png" }) {
          childImageSharp {
            fluid(quality: 95, maxWidth: 200) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <SectionOne id="section-one-kiosk">
        <HeroTitle>Esper Values</HeroTitle>
        <HeroSubTitle style={{ paddingTop: '1rem' }}>
          At Esper, we believe our values and love for our work has been key to
          our success and is core to our future. We are 100% committed to who we
          are and what we do. Our core values include:
        </HeroSubTitle>
        <CareerPageValuesSection>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.ownership.childImageSharp.fluid}
              alt="Esper Leadership is Ownership"
            />
            <BenefitsTitle>Leadership is Ownership</BenefitsTitle>
            <BenefitsDescription>
              Leaders are owners. We believe in long-term thinking and doesn’t
              sacrifice future value for short-term results. We act on behalf of
              the entire company, beyond just our own team.
            </BenefitsDescription>
          </ValueItem>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.people.childImageSharp.fluid}
              alt="Esper People First"
            />
            <BenefitsTitle>People First</BenefitsTitle>
            <BenefitsDescription>
              We truly believe in people over process. Our philosophy is that
              people thrive on being trusted, on freedom, and on being able to
              make a difference. So we foster freedom and empowerment wherever
              possible.
            </BenefitsDescription>
          </ValueItem>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.honesty.childImageSharp.fluid}
              alt="Esper Honesty and Integrity"
            />
            <BenefitsTitle>Honesty and Integrity</BenefitsTitle>
            <BenefitsDescription>
              Honesty benefits both you and others around you. Not only is it
              about telling the truth, but also promoting openness and
              empowering others. The truth lets us all focus on real challenges
              and progress.
            </BenefitsDescription>
          </ValueItem>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.batmanjoker.childImageSharp.fluid}
              alt="Esper Disagree Respectfully and Commit to Decisions"
            />
            <BenefitsTitle>
              Disagree Respectfully and Commit to Decisions
            </BenefitsTitle>
            <BenefitsDescription>
              Leaders are obligated to respectfully challenge decisions when
              they disagree, even when doing so is uncomfortable or exhausting.
              We believe in conviction and being tenacious. We do not compromise
              for the sake of social cohesion. But when the decision is made, we
              make it happen together.
            </BenefitsDescription>
          </ValueItem>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.raisethebar.childImageSharp.fluid}
              alt="Esper Raise the Bar"
            />
            <BenefitsTitle>Raise the Bar</BenefitsTitle>
            <BenefitsDescription>
              Leaders continually raise the bar and drive their teams to deliver
              high quality products, services and processes. We as a team ensure
              that problems are fixed and stay fixed.
            </BenefitsDescription>
          </ValueItem>
          <ValueItem>
            <ValueImg
              loading="lazy"
              fluid={data.diversity.childImageSharp.fluid}
              alt="Esper Diversity and Inclusion"
            />
            <BenefitsTitle>Diversity and Inclusion</BenefitsTitle>
            <BenefitsDescription>
              To be successful in a dynamic and fast-moving industry across many
              markets worldwide, a diverse team is critical to our success. We
              are inclusive to the varied ways of super effective and passionate
              people – be who you are and make it happen with us.
            </BenefitsDescription>
          </ValueItem>
        </CareerPageValuesSection>
      </SectionOne>
    )}
  />
);
